import { NotificationManager } from 'react-notifications'
import { sendData, getData } from './apiService.js'
export async function saveFeeback(values) {
  let response = await sendData('visits/feedback/store', values)
  if (response.success) {
    NotificationManager.success('Saved')
    return response.data
  }
  NotificationManager.error(response.message)
  return false
}

export async function deleteFeeback(id) {
  let response = await sendData('visits/feedback/delete', { id: id })
  if (response.success) {
    NotificationManager.success('Delete')
    return true;
  }
  NotificationManager.error(response.message)
  return false
}

export async function getFeedback(params) {
  let response = await getData('visits/feedback/get', params)
  if (response.success) {
    return response.data
  } else {
    NotificationManager.error(response.message)
    return false
  }
}
